import { Fragment, useState } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, SelectorIcon } from '@heroicons/react/solid'
import {find} from "lodash";
import cx from "classnames";

const ListboxSelect = props => {
    const { handleChange, items, value } = props
    const [selected, setSelected] = useState(value ?? null)

    const onChange = value => {
        const item = find(items, {value: value})

        setSelected(item)
        handleChange(item)
    }

    return (
        <div className="relative min-w-32">
            <Listbox value={selected?.value} onChange={onChange}>
                <div className="relative">
                    <Listbox.Button className="relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left shadow focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-indigo-300 sm:text-sm">
                        <span className="block truncate">{selected?.label}</span>
                        <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                            <SelectorIcon
                              className="h-5 w-5 text-gray-400"
                              aria-hidden="true"
                          />
                        </span>
                    </Listbox.Button>
                    <Transition
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-md ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                            {items.map(item => (
                                <Listbox.Option
                                    key={item.label}
                                    className={({active}) => cx('relative cursor-default select-none py-2 pl-10 pr-4', {'bg-indigo-800 text-white': active, 'text-gray-900': !active})}
                                    value={item.value}
                                >
                                    {({ selected, active }) => (
                                        <>
                                              <span
                                                  className={`block truncate ${
                                                      selected ? 'font-medium' : 'font-normal'
                                                  }`}
                                              >
                                                {item.label}
                                              </span>
                                            {selected ? (
                                                <span className={cx('absolute inset-y-0 left-0 flex items-center pl-3', {'text-white': active, 'text-indigo-800': !active})}>
                                                    <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                </span>
                                            ) : null}
                                        </>
                                    )}
                                </Listbox.Option>
                            ))}
                        </Listbox.Options>
                    </Transition>
                </div>
            </Listbox>
        </div>
    )
}

export default ListboxSelect
